import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-app-area-pie-chart',
  templateUrl: './app-area-pie-chart.component.html',
  styleUrls: ['./app-area-pie-chart.component.scss']
})
export class AppAreaPieChartComponent implements OnInit {
  private _zoneData : any;
  get zoneData(){
    return this._zoneData;
  }
  @Input() set zoneData(val: any) {
    this._zoneData = val;
    if (val) {
      this.zoneChart = {
        chart: {
          toolbar: {
            show: true
          },
          animations: {
            speed: 400,
            animateGradually: {
              enabled: false
            }
          },
          fontFamily: 'inherit',
          foreColor: 'inherit',
          height: '100%',
          type: 'pie',
          sparkline: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',
            // fontWeight: 'bold',
          },
          dropShadow: { enabled: false }
        },
        colors: ['#f55c41', '#fde6a8', '#edbc74', '#888787'],
        labels: this._zoneData.labels,
        plotOptions: {
          pie: {
            customScale: 0.9,
            expandOnClick: false,
            donut: {
              size: '70%'
            },
            dataLabels:{
              offset: -20,  style: {
                textShadow: false
              }
            }
          }
        },
        series: this._zoneData.series.map(e => e.percentageValue),
        states: {
          hover: {
            filter: {
              type: 'none'
            }
          },
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          theme: 'dark',
          custom: ({
                     seriesIndex,
                     w
                   }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                                                </div>`
        }
      };
    }
  }
  zoneChart: any;

  constructor() { }

  ngOnInit(): void {
  }

}
